export const addThermalPrintStyles = () => {
    const style = document.createElement('style')
    style.id = 'pdf-font-styles'

    style.innerHTML = `
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');
    
    .print-mode {
        width: 300px !important;
        max-width: 300px !important;
        background: white !important;
        padding: 0 !important;
        margin: 0 !important;
        font-family: 'Poppins', 'Montserrat', sans-serif !important;
        font-feature-settings: 'tnum' 1, 'kern' 1 !important;
        -webkit-font-smoothing: antialiased !important;
        -moz-osx-font-smoothing: grayscale !important;
        text-rendering: optimizeLegibility !important;
    }
    .print-mode .centeredProductHeader {
        text-align: center !important;
        margin: 0 !important;
        padding: 0 !important;
    }
    .print-mode .centeredContactRow {
        justify-content: center !important;
        align-items: center !important;
        margin: 0 !important;
        padding: 0 !important;
    }
    .print-mode .centeredContactLogo img {
        max-width: 40px !important;
        max-height: 40px !important;
        margin: 0 !important;
        padding: 0 !important;
    }
    .print-mode .centeredSupplierName {
        font-size: 16px !important;
        font-weight: 600 !important;
        line-height: 1.3 !important;
        text-align: center !important;
        font-family: 'Poppins', 'Montserrat', sans-serif !important;
        margin: 0 !important;
        padding: 0 !important;
    }
    .print-mode .centeredSupplierPhone {
        font-size: 14px !important;
        font-weight: 500 !important;
        line-height: 1.3 !important;
        text-align: center !important;
        font-family: 'Poppins', 'Montserrat', sans-serif !important;
        margin: 0 !important;
        padding: 0 !important;
    }
    .print-mode .centeredSupplierAddress {
        font-size: 10px !important;
        font-weight: 600 !important;
        line-height: 1.1 !important;
        text-align: center !important;
        justify-content: center !important;
        font-family: 'Poppins', 'Montserrat', sans-serif !important;
        margin: 0 !important;
        padding: 0 !important;
    }
        
    .print-mode .viewProductHeader {
        margin: 0 !important;
        padding: 0 !important;
    }
    .print-mode .ProductUniqueTag {
        font-size: 12px !important;
        font-weight: 600 !important;
        line-height: 1.1 !important;
        font-family: 'Poppins', 'Montserrat', sans-serif !important;
        margin: 0 !important;
        padding: 0 !important;
    }
    .print-mode .headerRowRight {
        font-size: 11px !important;
        font-weight: 600 !important;
        line-height: 1.1 !important;
        font-family: 'Poppins', 'Montserrat', sans-serif !important;
        font-variant-numeric: tabular-nums !important;
        margin: 0 !important;
        padding: 0 !important;
    }
    .print-mode .printTime{
        padding: 0 2px 0 0 !important;
    }
    .print-mode .cardCrown {
        font-size: 11px !important;
        font-weight: 600 !important;
        line-height: 1.1 !important;
        font-family: 'Poppins', 'Montserrat', sans-serif !important;
        margin: 0 !important;
        padding: 0 !important;
    }
    .print-mode .productSupplierName {
        font-size: 12px !important;
        font-weight: Bold !important;
        font-family: 'Poppins', 'Montserrat', sans-serif !important;
        margin: 0 !important;
        padding: 0 !important;
    }
    .print-mode .productSupplierAddress {
        font-size: 12px !important;
        font-weight: 400 !important;
        justify-content: flex-start !important;
        font-family: 'Poppins', 'Montserrat', sans-serif !important;
        margin: 0 !important;
        padding: 0 !important;
    }
    .print-mode .invoiceTable {
        font-size: 13px !important;
        width: 100% !important;
        border-collapse: collapse !important;
        font-family: 'Poppins', 'Montserrat', sans-serif !important;
        font-variant-numeric: tabular-nums !important;
        margin: 0 !important;
        padding: 0 !important;
    }

    .print-mode .invoiceTable th,
    .print-mode .invoiceTable td {
        font-size: 13px !important;
        font-weight: 400 !important;
        padding: 1px !important;
        padding-bottom: 4px !important;
        padding-top: 4px !important;
        line-height: 1.2 !important;
        text-align: center !important; 
        font-family: 'Poppins', 'Montserrat', serif !important;
        font-variant-numeric: tabular-nums !important;
        margin: 0 !important;
    }

    .print-mode .invoiceTable thead td {
        font-size: 13px !important;
        font-weight: 400 !important;
        background-color: #f8f9fa !important;
        text-align: center !important;
        font-family: 'Poppins', 'Montserrat', serif !important;
        margin: 0 !important;
        padding: 1px !important;
    }

    /* First two columns - left align */
    .print-mode .invoiceTable td:nth-child(1),
    .print-mode .invoiceTable td:nth-child(2) {
        text-align: left !important;
    }

    /* Third column - center align */
    .print-mode .invoiceTable td:nth-child(3) {
        text-align: center !important;
    }

    .print-mode .invoiceTable td:nth-child(4) {
        text-align: right !important;
        font-variant-numeric: tabular-nums !important;
        padding: 1px !important;
    }
    
    .print-mode .invoiceTable td:nth-child(5) {
        text-align: right !important;
        font-variant-numeric: tabular-nums !important;
        padding: 1px !important;
    }
    
    .print-mode .productPrice {
        font-size: 12px !important;
        width: 100% !important;
        border-collapse: collapse !important;
        font-family: 'Poppins', 'Montserrat', serif !important;
        font-variant-numeric: tabular-nums !important;
        margin: 0 !important;
        padding: 0 !important;
    }
    .print-mode .productPrice td {
        font-size: 12px !important;
        font-weight: 400 !important;
        padding: 1px !important;
        line-height: 1.3 !important;
        font-family: 'Poppins', 'Montserrat', serif !important;
        font-variant-numeric: tabular-nums !important;
        margin: 0 !important;
    }
    .print-mode .productPrice .strong {
        font-size: 14px !important;
        font-weight: 600 !important;
        font-family: 'Poppins', 'Montserrat', serif !important;
    }
    .print-mode .productPrice thead td {
        font-size: 12px !important;
        font-weight: 600 !important;
        background-color: #f8f9fa !important;
        text-align: center !important;
        font-family: 'Poppins', 'Montserrat', serif !important;
        margin: 0 !important;
        padding: 1px !important;
    }
    .print-mode .disclaimerNotes {
        padding: 0 !important;
        margin: 0 !important;
    }
    .print-mode .disclaimerNotesHeading {
        font-size: 13px !important;
        font-weight: 600 !important;
        line-height: 1.3 !important;
        font-family: 'Poppins', 'Montserrat', serif !important;
        margin: 0 !important;
        padding: 0 !important;
    }
    .print-mode .disclaimerNotesDesc {
        font-size: 12px !important;
        font-weight: 600 !important;
        line-height: 1.4 !important;
        font-family: 'Poppins', 'Montserrat', sans-serif !important;
        margin: 0 !important;
        padding: 0 !important;
    }
    .print-mode .boldText {
        font-weight: 600 !important;
        font-size: 12px !important;
        font-family: 'Poppins', 'Montserrat', serif !important;
    }
    .print-mode .tdWrap {
        font-size: 11px !important;
        font-weight: 400 !important;
        line-height: 1.2 !important;
        word-wrap: break-word !important;
        max-width: 120px !important;
        font-family: 'Poppins', 'Montserrat', serif !important;
    }
    .print-mode .textCenter {
        text-align: center !important;
    }
    .print-mode .contactDetailsRow {
        margin: 0 !important;
        padding: 0 !important;
    }
    .print-mode .productDescriptionWrap {
        margin: 0 !important;
        padding: 0 !important;
    }
    .print-mode .actionButton {
        display: none !important;
    }
    .print-mode .loader {
        display: none !important;
    }
    .print-mode .phoneWrapper {
        display: inline-flex !important;
        align-items: center !important;
        gap: 2px !important;
        font-weight: bold !important;
        line-height: 1 !important;
    }

    .print-mode .iconWrapper {
        font-size: 8px !important;
        display: inline-flex !important;
        align-items: center !important;
        transform: translateY(1px) !important;
    }

    .print-mode .phoneNumber {
        font-size: 12px !important;
        line-height: 1 !important;
    }
    
    /* Remove all gaps between elements */
    .print-mode * {
        margin: 0 !important;
    }
    
    .print-mode .headerRow {
        margin: 0 !important;
        padding: 0 !important;
    }
    
    .print-mode .mt-1,
    .print-mode .mt-5 {
        margin-top: 0 !important;
    }

    /* Pharmacy Copy Template Styles - Wider A4 Format */
    .print-mode.pharmacyCopyTemplate {
        width: 600px !important;
        max-width: 600px !important;
        padding: 15px !important;
    }

    .print-mode.pharmacyCopyTemplate .invoiceTitle {
        font-size: 14px !important;
        font-weight: 600 !important;
        margin-bottom: 10px !important;
    }

    .print-mode.pharmacyCopyTemplate .branchHeaderSection {
        margin-bottom: 8px !important;
        padding-bottom: 8px !important;
        border-bottom: 1px solid #ddd !important;
    }

    .print-mode.pharmacyCopyTemplate .branchInfoRow {
        display: flex !important;
        align-items: center !important;
        gap: 8px !important;
    }

    .print-mode.pharmacyCopyTemplate .branchInfoRow .branchName {
        font-size: 13px !important;
        font-weight: 600 !important;
    }

    .print-mode.pharmacyCopyTemplate .branchInfoRow .branchPhone {
        font-size: 11px !important;
    }

    .print-mode.pharmacyCopyTemplate .branchAddressRow {
        font-size: 10px !important;
        display: flex !important;
        align-items: center !important;
        gap: 4px !important;
    }

    .print-mode.pharmacyCopyTemplate .invoiceInfoSection {
        margin-bottom: 8px !important;
        padding-bottom: 8px !important;
        border-bottom: 1px solid #ddd !important;
    }

    .print-mode.pharmacyCopyTemplate .invoiceInfoRow {
        display: flex !important;
        justify-content: space-between !important;
        align-items: center !important;
    }

    .print-mode.pharmacyCopyTemplate .invoiceLeft {
        display: flex !important;
        align-items: center !important;
        gap: 6px !important;
    }

    .print-mode.pharmacyCopyTemplate .invoiceTypeBadge {
        font-size: 9px !important;
        padding: 2px 6px !important;
        border-radius: 3px !important;
        border: 1px solid #a5d6a7 !important;
        background-color: #e8f5e9 !important;
    }

    .print-mode.pharmacyCopyTemplate .invoiceTypeBadge.online {
        border: 1px solid #ffcc80 !important;
        background-color: #fff3e0 !important;
    }

    .print-mode.pharmacyCopyTemplate .servedByRow {
        display: flex !important;
        justify-content: flex-end !important;
        font-size: 10px !important;
        gap: 4px !important;
    }

    .print-mode.pharmacyCopyTemplate .customerSection {
        margin-bottom: 10px !important;
        padding-bottom: 8px !important;
        border-bottom: 1px solid #ddd !important;
    }

    .print-mode.pharmacyCopyTemplate .customerInfoRow {
        display: flex !important;
        align-items: center !important;
        gap: 8px !important;
    }

    .print-mode.pharmacyCopyTemplate .customerName {
        font-size: 12px !important;
        font-weight: 600 !important;
    }

    .print-mode.pharmacyCopyTemplate .customerAddressRow {
        font-size: 10px !important;
        display: flex !important;
        align-items: center !important;
        gap: 4px !important;
    }

    .print-mode.pharmacyCopyTemplate .invoiceTable.pharmacyCopyTable {
        width: 100% !important;
        border-collapse: collapse !important;
        font-size: 9px !important;
        margin-bottom: 10px !important;
        border: 1px solid #000 !important;
        table-layout: fixed !important;
    }

    .print-mode.pharmacyCopyTemplate .invoiceTable.pharmacyCopyTable th {
        font-size: 8px !important;
        font-weight: 600 !important;
        padding: 4px 3px !important;
        border: 1px solid #000 !important;
        background-color: #f5f5f5 !important;
        text-align: left !important;
        word-wrap: break-word !important;
        overflow-wrap: break-word !important;
    }

    .print-mode.pharmacyCopyTemplate .invoiceTable.pharmacyCopyTable td {
        font-size: 8px !important;
        padding: 4px 3px !important;
        border: 1px solid #000 !important;
        text-align: left !important;
        word-wrap: break-word !important;
        overflow-wrap: break-word !important;
        white-space: normal !important;
    }

    .print-mode.pharmacyCopyTemplate .summarySection {
        margin-bottom: 8px !important;
    }

    .print-mode.pharmacyCopyTemplate .summaryRow {
        display: flex !important;
        justify-content: flex-end !important;
        gap: 30px !important;
        font-size: 10px !important;
        padding: 2px 0 !important;
    }

    .print-mode.pharmacyCopyTemplate .summaryRow.totalRow {
        border-top: 1px solid #ddd !important;
        padding-top: 6px !important;
        margin-top: 4px !important;
    }

    .print-mode.pharmacyCopyTemplate .summaryRow .totalValue {
        font-size: 12px !important;
        font-weight: 700 !important;
    }

    .print-mode.pharmacyCopyTemplate .paymentModeSection {
        display: flex !important;
        justify-content: flex-end !important;
        gap: 8px !important;
        font-size: 11px !important;
        margin-bottom: 10px !important;
        padding-bottom: 8px !important;
        border-bottom: 1px solid #ddd !important;
    }

    .print-mode.pharmacyCopyTemplate .notesSection {
        margin-bottom: 10px !important;
    }

    .print-mode.pharmacyCopyTemplate .notesLabel {
        font-size: 10px !important;
        font-weight: 600 !important;
    }

    .print-mode.pharmacyCopyTemplate .notesContent {
        min-height: 25px !important;
        margin-top: 4px !important;
        padding: 6px !important;
        border: 1px solid #e0e0e0 !important;
        border-radius: 3px !important;
    }
`
    document.head.appendChild(style)
}
